import { z } from "zod";
import { loggedInApiCall } from "./axiosClient/userApi";
import type {
    OrganizationType,
    CreateOrganizationTypeRequest,
    UpdateOrganizationTypeRequest,
} from "../types/organizationType";

// Zod schemas for validation
export const organizationTypeSchema = z.object({
    id: z.number(),
    name: z.string(),
    isDefault: z.boolean(),
    isDeletable: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});

export const createOrganizationTypeSchema = z.object({
    name: z.string().min(2).max(255),
    isDefault: z.boolean().optional().default(false),
    isDeletable: z.boolean().optional().default(true),
});

export const updateOrganizationTypeSchema = z.object({
    name: z.string().min(2).max(255).optional(),
    isDefault: z.boolean().optional(),
    isDeletable: z.boolean().optional(),
});

// API functions
export const organizationTypeApi = {
    // Get all organization types
    getAll: async (): Promise<OrganizationType[]> => {
        const response = await loggedInApiCall.get("/api/organization_types");
        return response.data["hydra:member"];
    },

    // Get organization type by ID
    getById: async (id: number): Promise<OrganizationType> => {
        const response = await loggedInApiCall.get(`/api/organization_types/${id}`);
        return response.data;
    },

    // Create new organization type
    create: async (data: CreateOrganizationTypeRequest): Promise<OrganizationType> => {
        const validatedData = createOrganizationTypeSchema.parse(data);
        const response = await loggedInApiCall.post("/api/organization_types", validatedData);
        return response.data;
    },

    // Update organization type
    update: async (id: number, data: UpdateOrganizationTypeRequest): Promise<OrganizationType> => {
        const validatedData = updateOrganizationTypeSchema.parse(data);
        const response = await loggedInApiCall.put(`/api/organization_types/${id}`, validatedData);
        return response.data;
    },

    // Delete organization type
    delete: async (id: number): Promise<void> => {
        await loggedInApiCall.delete(`/api/organization_types/${id}`);
    },
};
